<template>
  <div class="table-page-wrapper">
    <div class="table-wrapper">
      <table-column
        @search="searchColumn"
        @refresh="toQuery"
        @change="changeColumn"
        :column="columns"
        :hide="hides"
        style="padding-bottom: 10px"
      >
        <el-button @click="add" type="warning" size="small">新增 </el-button>
      </table-column>

      <el-table
        v-loading="tableLoading"
        :data="tableData"
        height="80vh"
        :header-cell-style="{ background: '#fafafa' }"
        ref="report"
        row-key="id"
        lazy
        size="small"
        class="js-table"
        style="width: 100%"
      >
        <el-table-column
          v-for="(v, i) in checkColumns"
          :prop="v.field"
          :label="v.title"
          :width="v.width"
          :min-width="v.minWidth"
          :key="i"
          align="center"
        >
          <template v-slot="scope">
            <span v-if="v.field === 'subjectType'">
              {{ subjectTypeList[scope.row[v.field]] }}
            </span>
            <span v-else>{{ scope.row[v.field] }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" align="center" width="150">
          <template v-slot="scope" align="center">
            <el-button @click="update(scope.row)" type="success" size="mini"
              >编辑</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :total="pagination.total"
        :pager-count="6"
        :current-page="pagination.pageNum"
        :page-size="pagination.pageSize"
        :page-sizes="[10, 30, 60]"
        background
        layout="total,sizes,prev,pager,next"
        style="margin-top: 40px"
      />
    </div>
    <m-form @submit="addInfo" ref="form" title="主体信息" />

    <el-dialog title="请选择您要使用的主体" v-model="visible" width="400px">
      <el-radio-group v-model="subjectId">
        <el-radio v-for="item in tableData" :label="item.subjectId">{{ item.subjectName }}</el-radio>
      </el-radio-group>

      <div style="text-align: center;margin-top: 20px;">
        <el-button @click="visible = false">取消</el-button>
        <el-button type="primary" @click="sure">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

  <script>
  import TableColumn from '@/components/TableColumn'
  import mForm from './components/form'
  import { uuid } from '@/util/util'
  import { getMasterSubjectInfo } from '@/api/report/dsp'
  import initTableMixin from '@/mixins/initTable'
  import { downExcelMixin } from '@/mixins/downExcel'
  import { updateSubjectInfo } from '@/api/dashboard'



  export default {
    name: 'Subject',
    components: {
      TableColumn,
      mForm
    },
    mixins: [initTableMixin,downExcelMixin],
    data () {
      return {
        subjectTypeList: { 1: ' 结算主体', 2: '广告主主体',3:'渠道主体',4:'发票主体' },
        columns: [
          // { field: 'subjectId', title: '主体唯一编号' },
          { field: 'subjectName', title: '主体名称' },
          { field: 'subjectType', title: '主体类型' },
          { field: 'unitAccountName', title: '公司开户行' },
          { field: 'unitBankAccount', title: '公司银行账号' },
          { field: 'unitName', title: '公司名称' },
          { field: 'billingItems', title: '开票项目' },
          { field: 'identifier', title: '识别号' },
          { field: 'phoneNumber', title: '手机号' },
          { field: 'recipient', title: '收件人' },
          { field: 'registeredAddressPhone', title: '注册地址及电话' },
          { field: 'shippingAddress', title: '收件地址' },
        ],
        visible: false,
        hides: [
          'uniWinSmt', 'bidRate', 'cpcPrice', 'effectiveResSmt'
        ],
        subjectId: undefined,
        accountType: localStorage.getItem('accountType'),
        listData: [],
        subjectList:[]
      }
    },
    created(){
      this.getSubjectInfo()
    },
    mounted () {
      this.$nextTick(() => {
        this.init()
      })
    },
    methods: {
    add () {
      this.$refs.form.show()
    },
    update (row) {
      this.$refs.form.show(row)
    },
      getSubjectInfo(){
        getMasterSubjectInfo().then(res=>{
          this.subjectList = res.data
        })
      },
      beforeInit () {
        this.tableUrl = '/subjectInfo/get/subject/list'
        this.tableParams.pageNum = this.pagination.pageNum
        this.tableParams.pageSize = this.pagination.pageSize
        return true
      },
      afterInit (res) {
        this.tableData = this.generateTableId(res.data.records, 0)

      },
      sure () {
        updateSubjectInfo({ subjectId: this.subjectId })
        .then(res => {
          if (res.code === 200) {
            this.$message.success('选择主体成功！')
            this.visible = false
          }
        })
      },
      addInfo () {
        this.init()
        this.$nextTick(()=> {
          if ( this.accountType == 1 && this.tableData.length > 0 ) {
            this.visible = true
          }
        })
      },
      upTag (tag) {
        this.tableParams.tag = tag
      },
      sizeChange (e) {
        this.pagination.pageSize = e
        this.tableParams.pageSize = e
        this.init()
      },
      currentChange (e) {
        this.pagination.pageNum = e
        this.tableParams.pageNum = e
        this.init()
      },
      toQuery () {

        // if (this.dspSlotIdList) {
        //   this.tableParams.dspSlotIdList = this.dspSlotIdList.join(',')
        // }
        this.init()
      },

      generateTableId (data, base) {
        if (!data) return []
        for (let i = 0; i < data.length; i++) {
          data[i].id = uuid()

          if (base === 0) {
            data[i].hasChildren = true
          } else {
            data[i].dspSlotCode = data[i].slotId
            data[i].dspName = data[i].channelName
            data[i].dspSlotName = data[i].slotName
            data[i].dauDspSlotReqSmt = data[i].dauReqSmt
          }
        }
        return data
      },

    }
  }
  </script>

  <style scoped lang="scss">
.search-wrapper {
  padding: 15px 15px 5px;
  margin-bottom: 10px;
  background: #ffffff;

  & > * {
    margin-right: 15px;
    margin-bottom: 10px;

    &:last-child {
      margin-right: 0;
    }
  }

  & > .el-select,
  & > .el-input {
    width: 220px;
  }
}

.table-wrapper {
  padding: 15px;
  background: #ffffff;

  .table__operation {
    padding-bottom: 10px;
  }
}

.el-pagination {
  text-align: right;
}

::v-deep.el-table__expand-icon {
  width: auto !important;
}

::v-deep.el-table__body-wrapper {
  order: 0;
}
</style>
